var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"q-mb-md",attrs:{"flat":"flat","dense":"dense","color":"primary","icon":"chevron_left","label":"Back"},on:{"click":function($event){return _vm.$router.back()}}})}
var staticRenderFns = []

export { render, staticRenderFns }